export const WALKING_THRESHOLD = 0.1;
export const RUNNING_THRESHOLD = 3;
